import type { GenerateChatTitleParams } from 'tripPlanner/api/types'
import type { AssistantSurfaceContextSnapshot } from './types'
import { assertUnreachable } from 'lib/staticAssert/staticAssertUtils'

interface AssistantChatTitlePayload {
  chatId: number
  message: string
  surfaceContextSnapshot?: AssistantSurfaceContextSnapshot
}

export function mapAssistantChatTitlePayloadToGenerateChatTitleParams({
  chatId,
  message,
  surfaceContextSnapshot,
}: AssistantChatTitlePayload): GenerateChatTitleParams {
  if (!surfaceContextSnapshot) {
    return {
      chatId,
      message,
    }
  }

  switch (surfaceContextSnapshot.surface) {
    case 'trip_planner':
      return {
        chatId,
        message,
      }
    case 'accommodation_offer_page':
      return {
        chatId,
        message,
        surface: surfaceContextSnapshot.surface,
        surfaceContext: surfaceContextSnapshot.surfaceContext,
      }
    default:
      return assertUnreachable(surfaceContextSnapshot)
  }
}
